/**
 * @classdesc Korean Language Pack
 * @desc This class will used to translate tokens into the Korean language.
 * @namespace Languages.Korean
 */

/**
 * @constant dictionary
 * @type {object}
 * @memberof Languages.Korean
 */
export const dictionary = {
	'years'   : '년',
	'months'  : '월',
	'days'    : '일',
	'hours'   : '시',
	'minutes' : '분',
	'seconds' : '초'
};

/**
 * @constant aliases
 * @type {array}
 * @memberof Languages.Korean
 */
export const aliases = ['ko', 'ko-kr', 'korean'];
